import ViewMode from './EventListingViewMode';
import CalendarViewMode from './calendarView/EventsCalendarViewMode';
import { parseYYYYMMDD } from './date/DateHelpers';

// Use URLSearchParams if browser supports it, otherwise regex:
const params = 'URLSearchParams' in window ?
  new URLSearchParams(document.location.search.toLowerCase()) : {
    get: (name_) => {
      const name = name_.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
      const regex = new RegExp(`[\\?&]${name}=([^&#]*)`, 'i');
      const results = regex.exec(location.search);
      return !results ? results : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
  };


const search = {
  // loads specific keywords only (Note: Use of this parameter
  // will hide the keyword filters from the listing and calendar pages.)
  k: params.get('k'),

  // loads the page to display items beginning with the start date
  // (Note: Use of this parameter will hide the date range filter from the listing page.)
  startDate: params.get('startdate'),
  endDate: params.get('enddate'),

  hideDate: params.get('hidedate'),

  // loads the page in *either* the list view or the calendar view
  view: params.get('view'),

  // loads the calendar grid in a specific format; day, week, or month
  span: params.get('span'),
};

const startDate = parseYYYYMMDD(search.startDate);
const endDate = parseYYYYMMDD(search.endDate);
const hideListViewControls = search.hideDate !== null || !!startDate || !!endDate;
const hideListViewResultsHeading = search.hideDate !== null;
let forcedKeywords = null;
let defaultView = null;
let calendarViewMode = null;

if (search.k) {
  forcedKeywords = search.k.split(',');
}

if (
  search.view === ViewMode.CALENDAR ||
  search.view === ViewMode.LIST
) {
  defaultView = search.view;
}

if (
  search.span === CalendarViewMode.DAY ||
  search.span === CalendarViewMode.WEEK ||
  search.span === CalendarViewMode.MONTH
) {
  calendarViewMode = search.span;
}

// This exported object gets merged/assigned last to main EventListing config
const config = {
  forcedKeywords,
  hideListViewControls,
  hideListViewResultsHeading,
};

if (defaultView) {
  config.defaultView = defaultView;
  config.isMultiMode = false;
} else {
  config.isMultiMode = true;
}

// We only want to override the following properties if they're present:
if (calendarViewMode) {
  config.calendarViewMode = calendarViewMode;
}

if (startDate) {
  config.earliestEventDate = startDate;
  config.defaultDisplayDate = startDate;
}

if (endDate) {
  config.latestEventDate = endDate;
}

export default config;



// WEBPACK FOOTER //
// ./V7/events/listing/UrlSearchParamsConfig.js